const cache=new Map();
export const profileCache={get:id=>cache.get(id),set(id,value){cache.delete(id);cache.set(id,value);while(cache.size>20)cache.delete(cache.keys().next().value)},remove:id=>cache.delete(id)};
